import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getSuggestionChart = async (ctx: QueryFunctionContext) => {
  const {data}: {data: Array<ISuggestionChart>} = await request.get(
    `/api/v2/market/suggestion-chart?post_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
